export function BellFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M4.414 18H9a3 3 0 003 3 3.018 3.018 0 001.309-.3A3 3 0 0015 18h4.586c1.782 0 2.674-2.154 1.414-3.414l-2.093-2.093a33.856 33.856 0 00-.378-1.407c-.271-.93-.668-2.133-1.141-3.046-.43-.828-1.1-1.761-1.635-2.458-.272-.355-.52-.662-.699-.88l-.08-.097a3 3 0 00-5.948 0l-.08.097c-.18.218-.427.525-.7.88-.534.697-1.205 1.63-1.634 2.458-.473.913-.87 2.116-1.142 3.046a33.978 33.978 0 00-.377 1.407L3 14.586C1.74 15.846 2.632 18 4.414 18z"
      ></path>
    </svg>
  );
}
